// src/modules/finance.js
//
// Finance module manifest.
// Controls: Payments, AdminFinance, JobCosting routes and financialProductsStore.

export default {
  id: 'finance',
  label: 'Finance',

  stores: {
    financialProductsStore: {
      import: () => import('@/stores/financialProductsStore'),
      storeId: 'financialProductsStore',
      init: store => {
        store.fetchProducts()
      },
      cleanup: store => store.unsubscribeAll(),
    },
  },

  globalComponents: {}, // No global components

  routes: ['PaymentsPage', 'AdminFinance'],

  nav: [
    { label: 'Payments', routeName: 'PaymentsPage', group: 'finance' },
    { label: 'Admin Finance', routeName: 'AdminFinance', group: 'finance' },
  ],
}
